import { TransactionFieldConfig, TransactionFormConfig } from "./types";

// ─── Wspólne pola ────────────────────────────────────────────────────────────

const currencyField: TransactionFieldConfig = {
  name: "currencyUuid",
  label: "Waluta",
  type: "select",
  placeholder: "Wybierz walutę",
  required: true,
};

const fileField: TransactionFieldConfig = {
  name: "file",
  label: "Umowa",
  type: "file",
  accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png",
  required: false,
};


const defaultFields: TransactionFieldConfig[] = [
  // typeField,
  // quantityField,
  // unitPriceField,
  // totalValueField,
  // currencyField,
  // completedAtField,
  // noteField,
  // fileField,
];

export const getTransactionFormConfig = (slug: string, type?: string, currencyCode?: string): TransactionFormConfig => {
  if (slug === "treasury_bonds") {
    const isSell = type === "sell";
    return {
      slug,
      fields: [
        {
          name: "quantity",
          label: isSell
            ? "Ilość sprzedanych Obligacji Skarbowych"
            : "Ilość kupionych Obligacji Skarbowych",
          type: "number",
          placeholder: "",
          required: true,
          step: "any",
          precision: 2,
          maxLength: 12,
        },
        {
          name: "totalValue",
          label: isSell
            ? "Wartość sprzedanych Obligacji Skarbowych"
            : "Wartość kupionych Obligacji Skarbowych",
          type: "number",
          placeholder: "",
          required: false,
          step: "any",
          precision: 2,
          maxLength: 12,
        },
        {
          name: "unitPrice",
          label: "Wartość jednej obligacji skarbowej",
          type: "computed",
          computeValues: (values) => {
            const qty = Number(values.quantity);
            const total = Number(values.totalValue);
            if (!qty || !total || qty === 0) return "";
            return (total / qty).toLocaleString("pl-PL", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          },
        },
        {
          name: "completedAt",
          label: isSell ? "Data sprzedaży" : "Data transakcji",
          type: "date",
          required: true,
        },
        fileField,
      ],
    };
  }
  if (slug === "crypto" && type === "buy") {
    return {
      slug,
      fields: [
        {
          name: "quantity",
          label: "Ilość kupionych kryptowalut",
          type: "number",
          placeholder: "",
          required: true,
          step: "any",
          precision: 2,
          maxLength: 9,
        },
        {
          name: "unitPrice",
          label: "Kurs zakupu",
          type: "number",
          placeholder: "",
          required: false,
          step: "any",
          precision: 2,
          maxLength: 8,
        },
        {
          name: "totalValue",
          label: "Koszt nabycia",
          type: "computed",
          computeValues: (values) => {
            const qty = Number(values.quantity);
            const rate = Number(values.unitPrice);
            if (!qty || !rate) return "";
            const cost = qty * rate;
            const minDecimals = Number.isInteger(cost) ? 0 : 2;
            const formatted = cost
              .toLocaleString("en-US", {
                minimumFractionDigits: minDecimals,
                maximumFractionDigits: 8,
              })
              .replace(/,/g, "\u00A0");
            return currencyCode ? `${formatted} ${currencyCode}` : formatted;
          },
        },
        {
          name: "completedAt",
          label: "Data transakcji",
          type: "date",
          required: true,
        },
        fileField,
      ],
    };
  }
  if (slug === "crypto" && type === "sell") {
    return {
      slug,
      fields: [
        {
          name: "quantity",
          label: "Ilość sprzedanych kryptowalut",
          type: "number",
          placeholder: "",
          required: true,
          step: "any",
          precision: 2,
          maxLength: 12,
        },
        {
          name: "unitPrice",
          label: "Kurs sprzedaży",
          type: "number",
          placeholder: "",
          required: false,
          step: "any",
          precision: 2,
          maxLength: 12,
        },
        {
          name: "totalValue",
          label: "Koszt nabycia",
          type: "computed",
          computeValues: (values) => {
            const qty = Number(values.quantity);
            const rate = Number(values.unitPrice);
            if (!qty || !rate) return "";
            const cost = qty * rate;
            const minDecimals = Number.isInteger(cost) ? 0 : 2;
            const formatted = cost
              .toLocaleString("en-US", {
                minimumFractionDigits: minDecimals,
                maximumFractionDigits: 8,
              })
              .replace(/,/g, "\u00A0");
            return currencyCode ? `${formatted} ${currencyCode}` : formatted;
          },
        },
        {
          name: "completedAt",
          label: "Data transakcji",
          type: "date",
          required: true,
        },
        fileField,
      ],
    };
  }
  if (slug === "precious_stones" && type === "sell") {
    return {
      slug,
      fields: [
        {
          name: "quantity",
          label: "Masa sprzedanego kamienia szlachetnego",
          type: "number",
          placeholder: "",
          required: true,
          suffix: "g",
          step: "any",
          precision: 2,
          maxLength: 11,
        },
        {
          name: "totalValue",
          label: "Kwota zakupu",
          type: "number",
          placeholder: "",
          required: true,
          step: "any",
          precision: 2,
          maxLength: 12,
        },
        {
          name: "completedAt",
          label: "Data sprzedaży",
          type: "date",
          required: true,
        },
        fileField,
      ],
    };
  }
  if (slug === "precious_metals") {
    return {
      slug,
      fields: [
        {
          name: "quantity",
          label: type === "sell" ? "Masa sprzedanych metali szlachetnych" : "Masa",
          type: "number",
          placeholder: "",
          required: true,
          suffix: "g",
          step: "any",
          precision: 2,
          maxLength: 12,
        },
        {
          name: "totalValue",
          label: "Cena zakupu",
          type: "number",
          placeholder: "",
          required: true,
          step: "any",
          precision: 2,
          maxLength: 12,
        },
        currencyField,
        {
          name: "completedAt",
          label: type === "sell" ? "Data sprzedaży" : "Data transakcji",
          type: "date",
          required: true,
        },
        fileField,
      ],
    };
  }
  if (slug === "currencies") {
    const isSell = type === "sell";
    return {
      slug,
      fields: [
        {
          name: "totalValue",
          label: "Kwota",
          type: "number",
          placeholder: "",
          suffix: currencyCode || undefined,
          required: true,
          step: "any",
          precision: 2,
          maxLength: 12,
        },
        {
          name: "unitPrice",
          label: isSell ? "Kurs sprzedaży" : "Kurs zakupu",
          type: "number",
          placeholder: "",
          required: false,
          step: "any",
          precision: 2,
          maxLength: 8,
        },
        {
          name: "acquisitionCost",
          label: isSell ? "Koszt sprzedaży:" : "Koszt nabycia:",
          type: "computed",
          computeValues: (values) => {
            const totalVal = parseFloat(String(values.totalValue));
            const rate = parseFloat(String(values.unitPrice));
            if (!isNaN(totalVal) && !isNaN(rate) && totalVal > 0 && rate > 0) {
              const cost = totalVal * rate;
              return `${cost.toLocaleString("pl-PL", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })} PLN`;
            }
            return "";
          },
        },
        {
          name: "completedAt",
          label: "Data transakcji",
          type: "date",
          required: true,
        },
        fileField,
      ],
    };
  }
  return { slug, fields: defaultFields };
};

